<template>
  <div id="video_modal">
    <div v-if="videoData" class="video-modal-inner">
      <button @click="closeModal" class="btn-close">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
      <div v-html="videoData.embed" class="video-container"></div>
      <h4 class="video-title">{{ videoData.title }}</h4>
      <p class="video-paragraph">{{ videoData.blurb }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "VideoModal",
  props: ["videoData"],
  methods: {
    closeModal() {
      this.$bvModal.hide("video_modal");
    }
  }
};
</script>
<style lang="less">
#video_modal___BV_modal_content_ {
  border-radius: 12px;
}

#video_modal___BV_modal_footer_ {
  display: none;
}

#video_modal {
  .video-modal-inner {
    display: flex;
    flex-direction: column;
    max-width: 480px;
    padding: 32px;
    margin: 0 auto;
  }

  .btn-close {
    align-self: flex-end;
    padding: 14px 18px;
    border-radius: 8px;
    border: 0;
    background: rgba(25, 37, 80, 0.05);
    margin-bottom: 24px;

    .fa {
      font-size: 2rem;
    }
  }

  .video-container {
    position: relative;
    max-width: 100%;
    height: 240px;

    iframe {
      width: 100%;
    }

    iframe,
    .VideoThumbnail_module_videoThumbnail__d1b35579,
    .player.right-content-area-supported > .content-area-sibling-enabled {
      position: static !important;
    }
  }

  .video-title {
    color: #000;
    font-family: "PlusJakartaSansBold";
    font-size: 2rem;
    margin-top: 24px;
  }

  .video-paragraph {
    color: #1e1e22;
    font-family: "PlusJakartaSansRegular";
    font-size: 1.6rem;
    font-weight: 400;
    margin-top: 12px;
  }
}
</style>
